import Pristine from 'pristinejs';
import axios from 'axios';
import Swiper, { EffectFade } from 'swiper';

import '../../sass/blocks/survey.scss';

( () => {
    const $header = document.querySelector('header');
    const $surveys = document.querySelectorAll('.survey');

    if ( !$surveys ) return;

    $surveys.forEach( $survey => {
        let slider = null;
        const $surveyInputs = $survey.querySelectorAll('.survey__input');
        const $slider = $survey.querySelector('.survey__slider');
        const $sliderNextBtns = $survey.querySelectorAll('.survey__next-btn');

        if ( $header && $survey.classList.contains('is-first-block') ) {
            $header.classList.remove('light');
        }

        const submitForm = () => {
            const { AJAX_URL } = GLOBALS;

            const action = $survey.querySelector('[name=action]');
            const nonce = $survey.querySelector('[name=orangery_theme_submit_survey_wpnonce]');
            const pageId = $survey.querySelector('[name=page_id]');
            const blockId = $survey.querySelector('[name=block_id]');
            const surveyId = $survey.querySelector('[name=survey_id]');

            if ( !AJAX_URL || !action || !pageId || !blockId || !surveyId ) return;

            let params = {
                action: action.value,
                nonce: nonce.value,
                pageId: pageId.value,
                blockId: blockId.value,
                surveyId: surveyId.value
            };

            $surveyInputs.forEach( $input => {
                const { type, name, value, checked } = $input;

                if ( ( type === 'radio' || type === 'checkbox' ) && !checked ) return;

                params[name] = value;
            } );

            axios.get( AJAX_URL, {
                params
            } ).then( response => {
                slider.slideNext();
            } ).catch( error => {
                console.log(error?.response);

                if (error?.response?.data?.errors) {
                    error.response.data.errors.forEach( error => {
                        if ( !error?.name || !error?.message ) return;

                        const $errorMessageContainer = $survey.querySelector(`.pristine-error.${error.name}`);

                        if ( !$errorMessageContainer ) return;

                        $errorMessageContainer.innerHTML = error.message;
                        $errorMessageContainer.style = {
                            display: 'block'
                        };
                    } );
                }
            } ).finally( () => {
                $survey.classList.remove('loading');
            } );
        };

        const initSlider = () => {
            if ( !$slider ) return;

            slider = new Swiper($slider, {
                modules: [ EffectFade ],
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                allowTouchMove: false,
                simulateTouch: false,
                autoHeight: true
            });

            slider.on( 'slideChange', () => {
                $survey.querySelector('.anchor-link').scrollIntoView();
            } );

            if ( $sliderNextBtns ) {
                $sliderNextBtns.forEach( $sliderNextBtn => {
                    $sliderNextBtn.addEventListener( 'click', () => {
                        slider.slideNext();
                    } );
                } );
            }
        };

        const initSurvey = () => {
            var pristine = new Pristine($survey);

            $survey.addEventListener( 'submit', e => {
                $survey.classList.add('loading');

                e.preventDefault();

                if ( !pristine.validate() ) {
                    $survey.classList.remove('loading');
                    $survey.scrollIntoView();
                    return;
                }

                submitForm();
            } );
        };

        initSlider();
        initSurvey();
    } );
} )();
